import { IonPage, IonContent, IonText, IonButton, IonRange } from '@ionic/react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInitialConfigExtraProperty } from '../../../redux/reducer/initialConfigSlice'
import '../InitialConfiguration.min.css'
import InitialConfigHeader from '../header'
import measures from '../../../settings/measuresConfig'
import { useHistory } from 'react-router'

const AbdominalCircumferencePage = ({ step, totalSteps }) => {
	const history = useHistory()
	const measureIndex = measures.findIndex(
		(measure) => measure.value === 'abdominal_circumference'
	)
	const [isLoading, setIsLoading] = useState(false)
	const abdominal_circumference = useSelector(
		(state) =>
			state.initialConfig.extras.abdominal_circumference ||
			measures[measureIndex].initialValue
	)
	const dispatch = useDispatch()

	const updateInput = (e) => {
		dispatch(
			setInitialConfigExtraProperty({
				key: 'abdominal_circumference',
				value: e.detail.value,
			})
		)
	}

	const handleSkip = (e) => {
		setIsLoading(true)
		dispatch(
			setInitialConfigExtraProperty({
				key: 'abdominal_circumference',
				value: null,
			})
		)
		history.push(`/impostazioni-iniziali/${step + 1}`)
		setIsLoading(false)
	}

	const handleSubmit = () => {
		setIsLoading(true)
		history.push(`/impostazioni-iniziali/${step + 1}`)
		setIsLoading(false)
	}

	const handleDecrease = () => {
		const newValue = abdominal_circumference - measures[measureIndex].step
		dispatch(
			setInitialConfigExtraProperty({
				key: 'abdominal_circumference',
				value: Math.max(newValue, measures[measureIndex].min),
			})
		)
	}

	const handleIncrease = () => {
		const newValue = abdominal_circumference + measures[measureIndex].step
		dispatch(
			setInitialConfigExtraProperty({
				key: 'abdominal_circumference',
				value: Math.min(newValue, measures[measureIndex].max),
			})
		)
	}

	return (
		<IonPage className="initial-configuration">
			<InitialConfigHeader
				step={step}
				totalSteps={totalSteps}
				isLoading={isLoading}
			/>
			<IonContent>
				<h1>Circonferenza addome</h1>
				<IonRange
					min={measures[measureIndex].min}
					max={measures[measureIndex].max}
					step={measures[measureIndex].step}
					pinFormatter={(value) =>
						value.toFixed(2).replace('.', ',') +
						' ' +
						measures[measureIndex].suffix
					}
					pin={true}
					className="measure-range"
					onIonChange={updateInput}
					value={abdominal_circumference}
				/>
				<div className="measure-buttons">
					<IonButton
						shape="round"
						onClick={handleDecrease}
						disabled={isLoading}
						color="primary">
						-
					</IonButton>
					<IonButton
						shape="round"
						onClick={handleIncrease}
						disabled={isLoading}
						color="primary">
						+
					</IonButton>
				</div>
				<div className="buttons">
					<IonButton
						shape="round"
						onClick={handleSkip}
						disabled={isLoading}
						color="light-gray"
						expand="full">
						<IonText color="white">Salta</IonText>
					</IonButton>
					<IonButton
						shape="round"
						onClick={handleSubmit}
						disabled={isLoading}
						color="primary"
						expand="full">
						Avanti
					</IonButton>
				</div>
			</IonContent>
		</IonPage>
	)
}

export default AbdominalCircumferencePage
